import { useRef, useCallback } from "react";

const useScrollToBottom = () => {
  const containerRef = useRef(null);

  const scrollToBottom = useCallback((behavior = "auto") => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior,
      });
    }
  }, []);

  return [containerRef, scrollToBottom];
};

export default useScrollToBottom;
